export const colourWaysPath = (index, keyname, chIndex, chName) => {
  return {
    COMMONPATH: `[${index}][${keyname}]`,
    COLOURWAY_AS_SUPPLIERS: `[${index}].colourRefsDataAsPerSuppliers[${chIndex}][${chName}]`,
  };
};

export const colurwaysAsSuppliersPath = (index, chIndex, chName) => {
  return {
    COLOURWAY_AS_SUPPLIERS: `[${index}].colourRefsDataAsPerSuppliers[${chIndex}][${chName}]`,
  };
};

export const colurwaysAsPlacementPath = (index, chIndex, chName) => {
  return {
    COLOURWAY_AS_SUPPLIERS: `[${index}].colourRefsDataAsPerSuppliers[${chIndex}][${chName}]`,
  };
};
